
export const exercicios = [
  {
    id: 'ancoragem-emocional',
    titulo: 'Ancoragem Emocional PNL',
    subtitulo: 'Crie gatilhos instantâneos de estados emocionais positivos',
    descricao: 'Aprenda a técnica mais poderosa da Programação Neurolinguística para criar âncoras emocionais que ativam instantaneamente estados de confiança, motivação, calma ou qualquer emoção positiva que você desejar. Este exercício prático ensina passo a passo como programar seu cérebro para acessar recursos emocionais sob demanda, transformando sua capacidade de gerenciar emoções em qualquer situação.',
    categoria: 'PNL e Neurociência',
    duracao: '55 minutos',
    nivel: 'Intermediário',
    preco: 18.00,
    imagem: 'https://public.readdy.ai/ai/img_res/4cc1a2cb4c21c70906fa037fda32c82e.jpg',
    beneficios: [
      'Acesso instantâneo a estados emocionais positivos',
      'Controle emocional em situações desafiadoras',
      'Aumento de confiança e autoestima sob demanda',
      'Redução de ansiedade e estresse em segundos',
      'Melhora na performance em apresentações e reuniões',
      'Capacidade de mudar seu estado emocional rapidamente',
      'Criação de múltiplas âncoras para diferentes contextos',
      'Técnica validada pela neurociência moderna'
    ],
    aprendizados: [
      'O que são âncoras emocionais e como funcionam no cérebro',
      'Como identificar e acessar estados emocionais de pico',
      'Técnica completa de instalação de âncoras (visual, auditiva, cinestésica)',
      'Como empilhar âncoras para potencializar resultados',
      'Criar âncora de confiança para apresentações e entrevistas',
      'Instalar âncora de calma para momentos de estresse',
      'Desenvolver âncora de motivação para produtividade',
      'Como testar e reforçar suas âncoras ao longo do tempo',
      'Técnicas avançadas de colapso de âncoras negativas',
      'Aplicação prática em diferentes áreas da vida'
    ],
    relacionados: ['identidade-alta-performance', 'saude-bem-estar', 'prosperidade-carreira']
  },
  {
    id: 'encantations-tony-robbins',
    titulo: 'Encantations — Técnica Tony Robbins',
    subtitulo: 'Crie afirmações poderosas com movimento e emoção',
    descricao: 'Aprenda a técnica revolucionária de Tony Robbins que combina afirmações verbais com movimento físico e estado emocional intenso. Encantations vão muito além de simples afirmações — elas reprogramam seu sistema nervoso através da tríade corpo-mente-emoção, criando mudanças profundas e duradouras em sua identidade e resultados.',
    categoria: 'Alta Performance',
    duracao: '65 minutos',
    nivel: 'Intermediário',
    preco: 18.00,
    imagem: 'https://readdy.ai/api/search-image?query=powerful%20person%20doing%20physical%20movement%20with%20intense%20emotion%20energy%20radiating%20from%20body%20motivational%20scene%20dynamic%20pose%20strength%20confidence%20modern%20minimalist%20background%20professional%20photography%20high%20energy&width=800&height=600&seq=encantations001&orientation=landscape',
    beneficios: [
      'Reprogramação profunda de crenças limitantes',
      'Aumento exponencial de energia e motivação',
      'Mudança de estado emocional em minutos',
      'Criação de identidade de alta performance',
      'Ancoragem de estados de pico através do corpo',
      'Superação de medos e inseguranças',
      'Desenvolvimento de confiança inabalável',
      'Resultados mensuráveis em 21 dias de prática'
    ],
    aprendizados: [
      'O que são Encantations e como diferem de afirmações comuns',
      'A ciência por trás da técnica: neuroplasticidade e condicionamento',
      'Como criar suas próprias Encantations personalizadas',
      'A estrutura perfeita de uma Encantation poderosa',
      'Técnicas de movimento e fisiologia para potencializar',
      'Como acessar estados emocionais de pico durante a prática',
      'Rotina matinal de Encantations de Tony Robbins',
      'Criar Encantations para diferentes áreas da vida',
      'Como praticar em qualquer lugar (versão discreta)',
      'Medir e ajustar suas Encantations para máximos resultados',
      'Exemplos práticos de Encantations transformadoras',
      'Integrar Encantations em sua rotina diária'
    ],
    relacionados: ['ancoragem-emocional', 'identidade-alta-performance', 'proposito-vida']
  },
  {
    id: 'tecnica-swish-pnl',
    titulo: 'Técnica Swish (Switch) — PNL',
    subtitulo: 'Reprogramação rápida de respostas automáticas',
    descricao: 'Reprogramação rápida de respostas automáticas e substituição de padrões mentais indesejados. A Técnica Swish atua no nível subconsciente, alterando o gatilho interno que leva a um comportamento ou emoção. Em vez de lutar contra o padrão, você instala um novo.',
    categoria: 'PNL e Neurociência',
    duracao: '60 minutos',
    nivel: 'Intermediário',
    preco: 18.00,
    imagem: 'https://readdy.ai/api/search-image?query=brain%20neural%20pathways%20switching%20transformation%20mental%20pattern%20change%20visualization%20two%20contrasting%20images%20merging%20neuroscience%20concept%20modern%20clean%20background%20professional%20lighting%20high%20quality&width=800&height=600&seq=swish001&orientation=landscape',
    beneficios: [
      'Substituição rápida de padrões mentais indesejados',
      'Eliminação de procrastinação e autossabotagem',
      'Redução de ansiedade antecipatória',
      'Mudança de hábitos e compulsões leves',
      'Aumento de confiança em situações desafiadoras',
      'Controle sobre pensamentos negativos recorrentes',
      'Superação de medo de exposição e julgamento',
      'Instalação automática de novos padrões fortalecedores'
    ],
    aprendizados: [
      'O que é a Técnica Swish e como funciona no cérebro',
      'Identificar o comportamento ou emoção que deseja mudar',
      'Descobrir o gatilho interno que dispara o padrão',
      'Criar a imagem mental do seu "EU IDEAL"',
      'Ajustar as qualidades visuais das imagens para máximo impacto',
      'Executar o movimento "SWISH" de forma eficaz',
      'Técnica de limpeza da tela mental entre repetições',
      'Protocolo completo de repetição para instalação do padrão',
      'Como testar se a técnica funcionou',
      'Aplicar o Swish em diferentes situações do cotidiano',
      'Evitar os erros mais comuns na aplicação',
      'Quando usar e quando não usar a técnica'
    ],
    relacionados: ['ancoragem-emocional', 'encantations-tony-robbins', 'identidade-alta-performance']
  },
  {
    id: 'ressignificacao-reframing-pnl',
    titulo: 'Ressignificação (Reframing) — PNL',
    subtitulo: 'Transforme o significado de experiências limitantes',
    descricao: 'Técnica poderosa de PNL que permite mudar a perspectiva sobre eventos, comportamentos ou situações. Ao alterar o "frame" (moldura) através do qual você vê algo, você muda completamente seu significado e impacto emocional, criando novos significados empoderadores.',
    categoria: 'PNL e Neurociência',
    duracao: '55 minutos',
    nivel: 'Intermediário',
    preco: 18.00,
    imagem: 'https://readdy.ai/api/search-image?query=abstract%20perspective%20shift%20multiple%20viewpoints%20prism%20light%20refraction%20warm%20golden%20tones%20minimalist%20background%20representing%20cognitive%20flexibility%20and%20meaning%20transformation%20with%20geometric%20frames%20flowing%20shapes%20modern%20artistic%20style%20elegant%20composition&width=800&height=600&seq=reframe002&orientation=landscape',
    beneficios: [
      'Transformar experiências negativas em aprendizados valiosos',
      'Reduzir impacto emocional de eventos passados',
      'Encontrar oportunidades em situações desafiadoras',
      'Melhorar relacionamentos através de novas perspectivas',
      'Superar crenças limitantes rapidamente',
      'Desenvolver resiliência emocional profunda',
      'Criar significados empoderadores para sua história',
      'Aplicar em conflitos, traumas leves e bloqueios'
    ],
    aprendizados: [
      'O que é Reframing e como funciona no cérebro',
      'Diferença entre Reframing de Contexto e de Conteúdo',
      'Técnica dos 6 Passos do Reframing',
      'Como encontrar a intenção positiva por trás de comportamentos',
      'Reframing de crenças limitantes em capacitadoras',
      'Perguntas poderosas para mudar perspectivas',
      'Aplicar Reframing em situações do passado',
      'Usar Reframing preventivamente para o futuro',
      'Técnica do "E se..." para expandir possibilidades',
      'Reframing em relacionamentos e conflitos',
      'Como ensinar Reframing para outras pessoas',
      'Integrar Reframing em sua rotina diária'
    ],
    relacionados: ['tecnica-swish-pnl', 'linha-tempo-pnl', 'ancoragem-emocional', 'submodalidades-pnl']
  },
  {
    id: 'linha-tempo-pnl',
    titulo: 'Linha do Tempo (Timeline) — PNL',
    subtitulo: 'Reorganize sua história pessoal e liberte-se do passado',
    descricao: 'Técnica avançada de PNL que trabalha com a representação mental do tempo. Permite ressignificar eventos passados, liberar emoções negativas, eliminar decisões limitantes e criar um futuro alinhado com seus objetivos.',
    categoria: 'PNL e Neurociência',
    duracao: '75 minutos',
    nivel: 'Avançado',
    preco: 18.00,
    imagem: 'https://readdy.ai/api/search-image?query=abstract%20timeline%20past%20present%20future%20flowing%20golden%20path%20warm%20amber%20gradient%20minimalist%20background%20representing%20time%20perception%20personal%20history%20reorganization%20with%20linear%20elements%20geometric%20shapes%20light%20trails%20symbolizing%20temporal%20healing%20elegant%20modern%20style&width=800&height=600&seq=timeline002&orientation=landscape',
    beneficios: [
      'Liberar emoções negativas do passado (raiva, tristeza, medo, culpa)',
      'Eliminar decisões limitantes tomadas no passado',
      'Ressignificar eventos traumáticos leves',
      'Criar um futuro motivador e alinhado',
      'Aumentar sensação de controle sobre sua vida',
      'Melhorar autoestima reorganizando sua história pessoal',
      'Superar padrões repetitivos negativos',
      'Integrar aprendizados do passado de forma saudável'
    ],
    aprendizados: [
      'Como seu cérebro organiza e armazena o tempo',
      'Identificar sua Linha do Tempo pessoal (in-time vs through-time)',
      'Técnica de liberação de emoções negativas',
      'Processo de eliminação de decisões limitantes',
      'Como flutuar acima da sua linha do tempo',
      'Ressignificar eventos específicos do passado',
      'Criar eventos futuros motivadores na linha do tempo',
      'Técnica de preservação de aprendizados',
      'Integrar mudanças de forma ecológica',
      'Aplicar Timeline em diferentes áreas da vida',
      'Quando usar e quando não usar a técnica',
      'Cuidados éticos e de segurança emocional'
    ],
    relacionados: ['ressignificacao-reframing-pnl', 'ancoragem-emocional', 'tecnica-swish-pnl', 'submodalidades-pnl']
  },
  {
    id: 'submodalidades-pnl',
    titulo: 'Submodalidades — PNL',
    subtitulo: 'Domine os controles internos da sua mente',
    descricao: 'Domine os controles internos da sua mente alterando as qualidades sensoriais das suas representações mentais para mudar emoções e comportamentos. Submodalidades são as qualidades específicas das nossas representações internas — como brilho, tamanho, distância, volume e tom.',
    categoria: 'PNL e Neurociência',
    duracao: '50 minutos',
    nivel: 'Intermediário',
    preco: 18.00,
    imagem: 'https://readdy.ai/api/search-image?query=abstract%20sensory%20perception%20visualization%20five%20senses%20neural%20connections%20warm%20golden%20amber%20tones%20minimalist%20background%20representing%20internal%20mental%20controls%20brightness%20contrast%20size%20distance%20with%20elegant%20geometric%20dials%20and%20sliders%20modern%20artistic%20composition&width=800&height=600&seq=submod001&orientation=landscape',
    beneficios: [
      'Controlar a intensidade de qualquer emoção',
      'Diminuir o impacto de memórias dolorosas',
      'Amplificar estados emocionais positivos',
      'Reduzir ansiedade e medo rapidamente',
      'Eliminar fobias leves e desconfortos',
      'Aumentar motivação alterando representações internas',
      'Mudar a forma como você percebe situações',
      'Técnica base para todas as outras ferramentas de PNL'
    ],
    aprendizados: [
      'O que são submodalidades visuais, auditivas e cinestésicas',
      'Como mapear as submodalidades de qualquer experiência',
      'Identificar as submodalidades críticas (drivers)',
      'Técnica de diminuição de emoções negativas',
      'Amplificação de estados de recurso positivos',
      'Mapping Across: transferir qualidades entre experiências',
      'Como usar brilho, tamanho, distância e cor para mudar emoções',
      'Submodalidades auditivas: volume, tom, ritmo e localização',
      'Submodalidades cinestésicas: temperatura, pressão, movimento',
      'Aplicar em fobias leves, compulsões e hábitos',
      'Combinar com outras técnicas de PNL para resultados potentes',
      'Protocolo completo de autoaplicação segura'
    ],
    relacionados: ['tecnica-swish-pnl', 'ancoragem-emocional', 'ressignificacao-reframing-pnl', 'linha-tempo-pnl']
  },
  {
    id: 'modelagem-excelencia-pnl',
    titulo: 'Modelagem de Excelência — PNL',
    subtitulo: 'Copie os padrões mentais de quem já alcançou o que você deseja',
    descricao: 'Técnica avançada de PNL que permite identificar e replicar as estratégias mentais, crenças e comportamentos de pessoas que já alcançaram excelência em determinada área. Você aprende a "modelar" o sucesso de forma sistemática.',
    categoria: 'PNL e Neurociência',
    duracao: '70 minutos',
    nivel: 'Avançado',
    preco: 18.00,
    imagem: 'https://readdy.ai/api/search-image?query=abstract%20excellence%20modeling%20success%20blueprint%20golden%20neural%20network%20connections%20minimalist%20background%20representing%20mental%20patterns%20replication%20and%20mastery%20with%20geometric%20shapes%20flowing%20energy%20and%20symmetrical%20design%20symbolizing%20peak%20performance%20in%20modern%20elegant%20style&width=800&height=600&seq=model001&orientation=landscape',
    beneficios: [
      'Acelerar sua curva de aprendizado em qualquer área',
      'Identificar estratégias mentais de pessoas de sucesso',
      'Replicar padrões de excelência de forma sistemática',
      'Desenvolver habilidades complexas mais rapidamente',
      'Eliminar tentativa e erro desnecessários',
      'Criar seu próprio modelo de excelência personalizado',
      'Aplicar em carreira, relacionamentos, saúde e finanças',
      'Transformar admiração em ação prática'
    ],
    aprendizados: [
      'Os 4 pilares da Modelagem de Excelência',
      'Como escolher o modelo ideal para sua área de interesse',
      'Técnica de entrevista estratégica para extrair padrões',
      'Identificar crenças capacitadoras do modelo',
      'Mapear a estratégia mental passo a passo',
      'Descobrir os valores e critérios de decisão',
      'Observar fisiologia e linguagem corporal',
      'Testar e ajustar o modelo para sua realidade',
      'Criar seu próprio manual de excelência',
      'Combinar múltiplos modelos para resultados únicos',
      'Aplicar modelagem em diferentes contextos',
      'Evitar armadilhas comuns na modelagem'
    ],
    relacionados: ['identidade-alta-performance', 'tecnica-swish-pnl', 'ancoragem-emocional', 'ressignificacao-reframing-pnl']
  },
  {
    id: 'amor-ideal',
    titulo: 'Visualização do Amor Ideal',
    subtitulo: 'Atraia e fortaleça relacionamentos saudáveis',
    descricao: 'Uma jornada profunda de visualização para conectar-se com a essência do amor que você deseja manifestar em sua vida. Este exercício combina técnicas de PNL com visualização criativa para alinhar sua energia emocional com relacionamentos saudáveis e significativos.',
    categoria: 'Relacionamentos',
    duracao: '45 minutos',
    nivel: 'Intermediário',
    preco: 97,
    imagem: 'https://readdy.ai/api/search-image?query=elegant%20couple%20holding%20hands%20walking%20in%20beautiful%20garden%20at%20sunset%2C%20romantic%20atmosphere%2C%20soft%20golden%20light%2C%20peaceful%20and%20loving%20energy%2C%20dreamy%20aesthetic%2C%20luxury%20lifestyle%20photography%2C%20warm%20tones%2C%20intimate%20moment&width=800&height=600&seq=amor-ideal-hero&orientation=landscape',
    beneficios: [
      'Clareza sobre o tipo de relacionamento que você realmente deseja',
      'Identificação de padrões limitantes em relacionamentos passados',
      'Alinhamento energético com amor saudável e recíproco',
      'Visualização detalhada do seu parceiro(a) ideal',
      'Técnicas para atrair relacionamentos conscientes',
      'Exercícios de autoamor e preparação emocional',
      'Reprogramação de crenças sobre relacionamentos',
      'Práticas para manter relacionamentos saudáveis'
    ],
    aprendizados: [
      'Como usar visualização criativa para manifestar amor',
      'Técnicas de PNL aplicadas a relacionamentos',
      'Identificar e transformar padrões de relacionamento',
      'Criar uma visão clara do seu relacionamento ideal',
      'Práticas diárias de alinhamento emocional',
      'Como reconhecer relacionamentos saudáveis',
      'Fortalecer autoestima e amor próprio',
      'Manter a energia do amor em sua vida'
    ],
    relacionados: ['prosperidade-carreira', 'saude-bem-estar', 'proposito-vida']
  },
  {
    id: 'prosperidade-carreira',
    titulo: 'Prosperidade e Carreira',
    subtitulo: 'Clareza sobre sucesso profissional e financeiro',
    descricao: 'Um exercício transformador que combina visualização de abundância com planejamento estratégico de carreira. Conecte-se com sua versão mais próspera e bem-sucedida, identificando os passos práticos para alcançar seus objetivos profissionais e financeiros.',
    categoria: 'Carreira e Finanças',
    duracao: '50 minutos',
    nivel: 'Intermediário',
    preco: 97,
    imagem: 'https://readdy.ai/api/search-image?query=successful%20professional%20woman%20in%20elegant%20office%20with%20city%20view%2C%20confident%20posture%2C%20luxury%20workspace%2C%20golden%20hour%20lighting%2C%20abundance%20and%20prosperity%20energy%2C%20modern%20minimalist%20design%2C%20warm%20sophisticated%20tones&width=800&height=600&seq=prosperidade-hero&orientation=landscape',
    beneficios: [
      'Visão clara de seus objetivos profissionais e financeiros',
      'Identificação de oportunidades de crescimento',
      'Alinhamento entre propósito e carreira',
      'Reprogramação de crenças limitantes sobre dinheiro',
      'Estratégias práticas para aumentar renda',
      'Desenvolvimento de mentalidade de abundância',
      'Planejamento de carreira de longo prazo',
      'Confiança para buscar novas oportunidades'
    ],
    aprendizados: [
      'Visualizar sua carreira ideal em detalhes',
      'Identificar bloqueios financeiros inconscientes',
      'Criar um plano de ação para prosperidade',
      'Técnicas de manifestação de abundância',
      'Como tomar decisões profissionais alinhadas',
      'Desenvolver autoconfiança profissional',
      'Estabelecer metas financeiras realistas',
      'Manter foco e disciplina em seus objetivos'
    ],
    relacionados: ['identidade-alta-performance', 'proposito-vida', 'amor-ideal']
  },
  {
    id: 'saude-bem-estar',
    titulo: 'Saúde e Bem-Estar Futuro',
    subtitulo: 'Visualização da versão saudável e equilibrada',
    descricao: 'Uma experiência imersiva de conexão com sua versão mais saudável, vibrante e equilibrada. Este exercício utiliza visualização guiada e técnicas de ancoragem para criar motivação genuína e duradoura para cuidar do seu corpo, mente e espírito.',
    categoria: 'Saúde e Bem-Estar',
    duracao: '40 minutos',
    nivel: 'Básico',
    preco: 97,
    imagem: 'https://readdy.ai/api/search-image?query=peaceful%20woman%20practicing%20yoga%20at%20sunrise%20in%20nature%2C%20healthy%20lifestyle%2C%20serene%20atmosphere%2C%20soft%20morning%20light%2C%20wellness%20and%20vitality%2C%20balanced%20energy%2C%20natural%20beauty%2C%20warm%20golden%20tones%2C%20harmonious%20composition&width=800&height=600&seq=saude-hero&orientation=landscape',
    beneficios: [
      'Conexão profunda com sua saúde ideal',
      'Motivação genuína para hábitos saudáveis',
      'Visualização de seu corpo em equilíbrio',
      'Identificação de áreas que precisam de atenção',
      'Criação de rotinas de autocuidado',
      'Alinhamento mente-corpo-espírito',
      'Redução de resistência a mudanças saudáveis',
      'Energia renovada para transformação'
    ],
    aprendizados: [
      'Visualizar sua versão mais saudável e vibrante',
      'Identificar hábitos que impactam sua saúde',
      'Criar um plano de bem-estar personalizado',
      'Técnicas de ancoragem para motivação',
      'Como manter disciplina com autocuidado',
      'Práticas de mindfulness para saúde',
      'Estabelecer metas de saúde realistas',
      'Cultivar amor e respeito pelo seu corpo'
    ],
    relacionados: ['amor-ideal', 'proposito-vida', 'identidade-alta-performance']
  },
  {
    id: 'proposito-vida',
    titulo: 'Propósito de Vida',
    subtitulo: 'Para quem sente que nasceu para algo maior',
    descricao: 'Uma jornada profunda de autoconhecimento para descobrir ou reconectar-se com seu propósito de vida. Este exercício combina reflexões existenciais, visualização de legado e técnicas de clareza para revelar o que você veio fazer neste mundo.',
    categoria: 'Propósito e Significado',
    duracao: '60 minutos',
    nivel: 'Avançado',
    preco: 147,
    imagem: 'https://readdy.ai/api/search-image?query=person%20standing%20on%20mountain%20peak%20at%20dawn%20with%20arms%20open%2C%20inspiring%20landscape%2C%20vast%20horizon%2C%20golden%20sunrise%20light%2C%20sense%20of%20purpose%20and%20achievement%2C%20spiritual%20awakening%2C%20majestic%20nature%2C%20warm%20ethereal%20tones&width=800&height=600&seq=proposito-hero&orientation=landscape',
    beneficios: [
      'Clareza profunda sobre seu propósito de vida',
      'Conexão com seus dons e talentos únicos',
      'Alinhamento entre valores e ações diárias',
      'Visão clara do legado que deseja deixar',
      'Motivação renovada para viver com significado',
      'Identificação de sua missão pessoal',
      'Direcionamento para decisões importantes',
      'Paz interior e senso de pertencimento'
    ],
    aprendizados: [
      'Descobrir ou clarificar seu propósito de vida',
      'Identificar seus dons e talentos naturais',
      'Conectar propósito com carreira e relacionamentos',
      'Criar uma declaração de propósito pessoal',
      'Visualizar o impacto que deseja causar',
      'Alinhar vida cotidiana com propósito maior',
      'Superar medos que bloqueiam seu propósito',
      'Viver com mais significado e plenitude'
    ],
    relacionados: ['identidade-alta-performance', 'prosperidade-carreira', 'amor-ideal']
  },
  {
    id: 'identidade-alta-performance',
    titulo: 'Identidade de Alta Performance',
    subtitulo: 'Construção da mentalidade da sua melhor versão',
    descricao: 'Um exercício intensivo de transformação de identidade baseado em princípios de alta performance e PNL avançada. Construa a mentalidade, hábitos e crenças da pessoa que você precisa ser para alcançar resultados extraordinários em todas as áreas da vida.',
    categoria: 'Alta Performance',
    duracao: '70 minutos',
    nivel: 'Avançado',
    preco: 197,
    imagem: 'https://readdy.ai/api/search-image?query=confident%20successful%20person%20in%20elegant%20attire%20walking%20with%20purpose%2C%20powerful%20presence%2C%20luxury%20urban%20setting%2C%20dramatic%20lighting%2C%20high%20performance%20energy%2C%20sophisticated%20aesthetic%2C%20strong%20composition%2C%20warm%20refined%20tones&width=800&height=600&seq=alta-performance-hero&orientation=landscape',
    beneficios: [
      'Transformação profunda de identidade pessoal',
      'Desenvolvimento de mentalidade de alta performance',
      'Criação de hábitos de excelência',
      'Reprogramação de crenças limitantes',
      'Aumento significativo de autoconfiança',
      'Clareza sobre padrões de comportamento',
      'Alinhamento total com sua melhor versão',
      'Resultados extraordinários em todas as áreas'
    ],
    aprendizados: [
      'Construir uma identidade de alta performance',
      'Identificar e eliminar autossabotagem',
      'Criar rituais diários de excelência',
      'Desenvolver disciplina e foco inabaláveis',
      'Técnicas avançadas de reprogramação mental',
      'Como pensar e agir como sua melhor versão',
      'Manter consistência em alto nível',
      'Alcançar resultados extraordinários'
    ],
    relacionados: ['encantations-tony-robbins', 'proposito-vida', 'prosperidade-carreira']
  }
];

export const pacotePNL = {
  id: 'pacote-pnl-completo',
  titulo: 'Pacote Completo PNL',
  subtitulo: 'Todas as 6 técnicas de PNL por um preço especial',
  precoOriginal: 108.00,
  precoPromocional: 47.00,
  economia: 61.00,
  percentualDesconto: 56,
  exerciciosIncluidos: [
    'ancoragem-emocional',
    'encantations-tony-robbins',
    'tecnica-swish-pnl',
    'ressignificacao-reframing-pnl',
    'linha-tempo-pnl',
    'submodalidades-pnl'
  ],
  beneficios: [
    'Acesso vitalício a todas as 6 técnicas',
    'Worksheets interativos inclusos',
    'Economia de mais de 56%',
    'Certificado de conclusão',
    'Atualizações futuras gratuitas',
    'Suporte por 90 dias'
  ]
};
